import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services';
import { isLocalhost } from '../../../main';

@Injectable({
  providedIn: 'root',
})
export class PublicGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  // Routing checks and redirects based on the user's authentication status
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // User not logged in and route is not public
    if (!this.authService.isAuthTokenValide() && !route.data.public) {
      this.authService.logout(false);
      this.router.navigate(['/login']);
      return false;

      // User logged in and route is public
    } else if (
      this.authService.isAuthTokenValide() &&
      route.data.public &&
      route.queryParams['goToStore'] != 'true'
    ) {
      this.router.navigate(['/auth/redirect']);
      return false;
    } else if (isLocalhost) {
      return true;
    } else if (
      state.url.includes('auth') &&
      state.url != '/auth' &&
      state.url != '/auth/redirect' &&
      state.url != '/auth/payment-succeeded-4e87a1aa' &&
      state.url != '/auth/payment-canceled-b0e5bb07' &&
      !state.url.includes('/upgrade-flow')
    ) {
      this.router.navigate(['/auth/redirect']);
      return false;
    }

    return true;
  }
}
